import React, { useState } from 'react'
import styles from './styles.module.scss'
import CTAWrapper from '../CTAWrapper'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Pill from 'srcReact/components/common2/Pill'

function CTAInterestSuggestions() {
  const { t } = useTranslation()

  const {
    feedHome: { ctas },
    myProfile: {
      userInterests: { list: userInterestList }
    }
  } = useSelector((state) => state)

  return ctas?.interest_suggestions?.length > 0 ? (
    <CTAWrapper title={t('feedCTAs.suggestedInterestsTitle')}>
      <div className={styles.interestWrapper}>
        {ctas.interest_suggestions.map((interest) => {
          const isUserInterestExist = userInterestList.some((int) => int.id == interest.id)
          return (
            <Pill
              selected={isUserInterestExist}
              dataId={interest.id}
              key={interest.id}
              text={interest.name}
              askForAddToProfile={true}
            />
          )
        })}
      </div>
    </CTAWrapper>
  ) : null
}

export default CTAInterestSuggestions
